export default __webpack_public_path__ + "static/media/Asporto Icon@4x.e632b468.svg";